

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListTransition extends Vue {
    @Prop({ default: () => [] })
    private listItem!: any[];

    @Prop({ default: () => ({}) })
    private pageSettings!: any;

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private copyCode(code: string) {
        if (!code) {
            return;
        }
        if (navigator.clipboard) {
            navigator.clipboard.writeText(code);
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Đã sao chép!',
                text: `Đã sao chép mã ${code}`,
            });
        }
    }
}
